module.exports = __webpack_public_path__ + "static/img/EH.186d0c3f.svg";